import React, { useState } from "react";
import usePWAInstall from "../usePWAInstall";
import Localize from "../../Localize/Localize";
import LocalizeKeys from "../../Localize/LocalizeKeys";
import DeepLinkUtils from "../../Utils/DeepLinkUtils";
import UserAgent from "../../Utils/UserAgent";
import Constants from "../../Constants";
import cookieManager from "../../CookieManager";
import "../install-banner.css";
import RemoteConfigService from "../../RemoteConfigService";

const renderOpenInBrowserBanner = (setDismissed) => {
    const rawUrl = window.location.href;
    const urlObj = new URL(rawUrl);

    const extra = new URLSearchParams();
    const atName = Constants.ACCESS_TOKEN;
    const rtName = Constants.REFRESH_TOKEN;
    const siName = Constants.SKILLS_ID;

    const atCookie = cookieManager.get(atName);
    const rtCookie = cookieManager.get(rtName);
    const siCookie = cookieManager.get(siName);

    if (atCookie && !urlObj.searchParams.has(atName)) extra.set(atName, atCookie);
    if (rtCookie && !urlObj.searchParams.has(rtName)) extra.set(rtName, rtCookie);
    if (siCookie && !urlObj.searchParams.has(siName)) extra.set(siName, siCookie);

    const paramsString = extra.toString();
    const intentHref = DeepLinkUtils.openInExternalBrowser(urlObj.toString(), paramsString);

    return (
        <div className="pwa-banner" role="dialog" aria-live="polite">
            <div className="pwa-banner__content">
                <div className="pwa-banner__text">
                    {Localize.translate(LocalizeKeys.INSTALL_EXTERNAL_BROWSER_MESSAGE)}
                </div>
                <a
                    href={intentHref}
                    className="pwa-banner__btn"
                    rel="noopener noreferrer"
                    data-external-intent="true"
                    onClick={() => setDismissed(true)}
                >
                    {Localize.translate(LocalizeKeys.INSTALL_EXTERNAL_BROWSER_BUTTON)}
                </a>
            </div>
            <button className="pwa-banner__close" onClick={() => setDismissed(true)} aria-label="Close">
                ×
            </button>
        </div>
    );
};

const renderInstallPWABanner = (handleInstallClick, setDismissed) => (
    <div className="pwa-banner" role="dialog" aria-live="polite">
        <div className="pwa-banner__content">
            <div className="pwa-banner__text">
                {Localize.translate(LocalizeKeys.INSTALL_APP)}
            </div>
            <button className="pwa-banner__btn" onClick={handleInstallClick}>
                {Localize.translate(LocalizeKeys.INSTALL_BUTTON)}
            </button>
        </div>
        <button className="pwa-banner__close" onClick={() => setDismissed(true)} aria-label="Close">
            ×
        </button>
    </div>
);

const renderManualInstallBanner = (setDismissed) => (
    <div className="pwa-banner" role="dialog" aria-live="polite">
        <div className="pwa-banner__help">
            <p>
                {Localize.translateByBrowserOrFallback(LocalizeKeys.INSTALL_ANDROID_MANUAL)}
            </p>
        </div>
        <button className="pwa-banner__close" onClick={() => setDismissed(true)} aria-label="Close">
            ×
        </button>
    </div>
);

const AndroidInstallBanner = () => {
    const { canInstall, promptInstall, isStandalone, supportsManualAddToHome } = usePWAInstall();
    const [dismissed, setDismissed] = useState(false);

    const openInExternalBrowser = !canInstall && !isStandalone && UserAgent.isEmbeddedWebView();

    console.log("[PWA] AndroidInstallBanner", {
        canInstall,
        openInExternalBrowser,
        supportsManualAddToHome,
    });

    if (dismissed || isStandalone) return null;

    const handleInstallClick = async () => {
        const result = await promptInstall();
        console.log("[PWA] AndroidInstallBanner outcome:", result.outcome);
        setDismissed(true);
    };

    if (openInExternalBrowser && RemoteConfigService.getLandingConfigValue("ToastOpenExternalBrowser"))
        return renderOpenInBrowserBanner(setDismissed);

    if (canInstall && RemoteConfigService.getLandingConfigValue("ToastInstallPWA")) {
        if (UserAgent.isSamsung()) {
          return renderManualInstallBanner(setDismissed);
        }
        else {
          return renderInstallPWABanner(handleInstallClick, setDismissed);
        }
    }

    if (supportsManualAddToHome && UserAgent.isAndroid() && RemoteConfigService.getLandingConfigValue("ToastAddFavorites"))
        return renderManualInstallBanner(setDismissed);

    return null;
};

export default AndroidInstallBanner;
